import styled, { createGlobalStyle } from 'styled-components'
import { Field } from 'formik'

export const BannerText = styled.p`
	color: #666;
	margin: 0.5rem 0;
	font-size: 0.9rem;
	line-height: 1.6;

	&:last-child {
		margin-top: 1rem;
		font-weight: 500;
		color: #333;
	}
`

export const CharacterCount = styled.div<{ isOverLimit: boolean }>`
	width: 90%;
	text-align: right;
	margin-top: 0.5rem;
	font-size: 0.9rem;
	color: ${(props) => (props.isOverLimit ? '#e21717' : '#666')};
	font-weight: ${(props) => (props.isOverLimit ? '600' : '400')};
`

export const BigTextArea = styled(Field)`
	width: 100%;
	min-height: 200px;
	padding: 0.75rem 1rem;
	background: #fff;
	border: 1px solid #d1d1d1;
	border-radius: 3px;
	font-size: 1rem;
	line-height: 1.5;
	resize: vertical;
	font-family: inherit;
	box-sizing: border-box;
	
	&:focus {
		outline: none;
		border-color: #bd5f28;
	}
	
	&::placeholder {
		color: #999;
	}
`

export const CrisisTextAreaStyles = createGlobalStyle`
	textarea[name="message"] {
		height: 200px !important;
		min-height: 200px !important;
		resize: vertical !important;
	}
`

export const TextAreaWrapper = styled.div`
	width: 90%;
	padding: 1rem 0;
	
	& > div {
		width: 100%;
	}
`
